export default [
  {
    path: '/spettacoli',
    name: 'spettacoli',
    component: () => import('@/views/produzioni/PaginaSpettacoli.vue'),
    meta: {
      resource: 'spettacoli',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Spettacoli',
          active: true,
        },
      ],
    },
  },
  {
    path: '/scritture',
    name: 'scritture',
    component: () => import('@/views/produzioni/PaginaScritture.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Scritture',
          active: true,
        },
      ],
    },
  },
  {
    path: '/altrescritture',
    name: 'altrescritture',
    component: () => import('@/views/produzioni/PaginaAltreScritture.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Altre Scritture',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ricevute',
    name: 'ricevute',
    component: () => import('@/views/produzioni/PaginaRicevute.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Ricevute',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cedolini',
    name: 'cedolini',
    component: () => import('@/views/produzioni/PaginaCedolini.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Cedolini',
          active: true,
        },
      ],
    },
  },
  {
    path: '/allestimenti-produzioni',
    name: 'allestimenti-produzioni',
    component: () => import('@/views/produzioni/PaginaAllestimenti.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Allestimenti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/costo-produzioni',
    name: 'costo-produzioni',
    component: () => import('@/views/produzioni/PaginaCostoProduzioni.vue'),
    meta: {
      resource: 'produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Costo Produzioni',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bilancio-produzioni',
    name: 'bilancio-produzioni',
    component: () => import('@/views/produzioni/PaginaBilancioProduzioni.vue'),
    meta: {
      resource: 'produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Bilancio Produzioni',
          active: true,
        },
      ],
    },
  },
  {
    path: '/costo-spettacolo',
    name: 'costo-spettacolo',
    component: () => import('@/views/produzioni/PaginaCostoSpettacolo.vue'),
    meta: {
      resource: 'sviluppo',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Costo Spettacolo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bilancio-ministero',
    name: 'bilancio-ministero',
    component: () => import('@/views/produzioni/PaginaBilancioMinistero.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Bilancio Ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/personale-ministero-produzioni',
    name: 'personale-ministero-produzioni',
    component: () => import('@/views/produzioni/PaginaPersonaleMinistero.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Personale Ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/calendario-ministero-produzioni',
    name: 'calendario-ministero-produzioni',
    component: () => import('@/views/produzioni/PaginaCalendarioMinistero.vue'),
    meta: {
      resource: 'calendario-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Calendario Ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/altrespese',
    name: 'altrespese',
    component: () => import('@/views/produzioni/PaginaAltreSpese.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Altre Spese',
          active: true,
        },
      ],
    },
  },
  {
    path: '/entrate',
    name: 'entrate',
    component: () => import('@/views/produzioni/PaginaEntrate.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Entrate',
          active: true,
        },
      ],
    },
  },
  {
    path: '/excel-ministero',
    name: 'excel-ministero',
    component: () => import('@/views/produzioni/PaginaExcelMinistero.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Ministero',
        },
        {
          text: 'Export Excel ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/oneri-lavoro',
    name: 'oneri-lavoro',
    component: () => import('@/views/produzioni/PaginaImportaOneriLavoro.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Oneri',
        },
        {
          text: 'Importa oneri lavoro',
          active: true,
        },
      ],
    },
  },
  {
    path: '/quote-oneri-personale',
    name: 'quote-oneri-personale',
    component: () => import('@/views/produzioni/PaginaImportaOneriPersonale.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Oneri Personale',
        },
        {
          text: 'Importa Oneri Consuntivi Personale',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pratiche-vvf',
    name: 'pratiche-vvf',
    component: () => import('@/views/produzioni/PaginaVigiliDelFuoco.vue'),
    meta: {
      resource: 'spettacoli',
      action: 'read',
      breadcrumb: [
        {
          text: 'Pratiche VVF',
        },
        {
          text: 'Visualizza Pratiche VVF',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pratiche-siae',
    name: 'pratiche-siae',
    component: () => import('@/views/produzioni/PaginaSIAE.vue'),
    meta: {
      resource: 'spettacoli',
      action: 'read',
      breadcrumb: [
        {
          text: 'Pratiche SIAE',
        },
        {
          text: 'Visualizza Pratiche SIAE',
          active: true,
        },
      ],
    },
  },
  {
    path: '/protocollo',
    name: 'protocollo',
    component: () => import('@/views/produzioni/PaginaProtocollo.vue'),
    meta: {
      resource: 'spettacoli',
      action: 'read',
      breadcrumb: [
        {
          text: 'Protocollo',
        },
        {
          text: 'Crea nuovi codici protocollo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bilancio-coccia',
    name: 'bilancio-coccia',
    component: () => import('@/views/produzioni/PaginaBilancioCoccia.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Bilancio Coccia',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importa-bilancio-coccia',
    name: 'importa-bilancio-coccia',
    component: () => import('@/views/produzioni/PaginaImportaBilancioCoccia.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Importa Bilancio Coccia',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importa-bilancio-preventivo-coccia',
    name: 'importa-bilancio-preventivo-coccia',
    component: () => import('@/views/produzioni/PaginaImportaBilancioPreventivoAnno.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Importa Bilancio Preventivo Coccia',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verifica-bilancio-coccia',
    name: 'verifica-bilancio-coccia',
    component: () => import('@/views/produzioni/PaginaVerificaBilancioCoccia.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Verifica Bilancio Coccia',
          active: true,
        },
      ],
    },
  },
  {
    path: '/punteggi-ministero',
    name: 'punteggi-ministero',
    component: () => import('@/views/produzioni/PaginaPunteggiMinistero.vue'),
    meta: {
      resource: 'personale-produzioni',
      action: 'read',
      breadcrumb: [
        {
          text: 'Produzioni',
        },
        {
          text: 'Visualizza Punteggi Ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mostra-oneri-personale',
    name: 'mostra-oneri-personale',
    component: () => import('@/views/produzioni/PaginaMostraOneriPersonale.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Oneri Personale',
        },
        {
          text: 'Mostra Oneri Personale',
          active: true,
        },
      ],
    },
  },
  {
    path: '/modelloC',
    name: 'modelloC',
    component: () => import('@/views/produzioni/PaginaModelloC.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Modello C',
        },
        {
          text: 'Mostra Modello C',
          active: true,
        },
      ],
    },
  },
  {
    path: '/allegatiDE',
    name: 'allegatiDE',
    component: () => import('@/views/produzioni/PaginaAllegatiDE.vue'),
    meta: {
      resource: 'scritture',
      action: 'read',
      breadcrumb: [
        {
          text: 'Allegati DE',
        },
        {
          text: 'Mostra Allegati DE',
          active: true,
        },
      ],
    },
  },
]
